import {
    ChipList as UiChipList,
    styledForMobile,
    styled,
    Typography,
} from "@l2r-front/l2r-ui"

export const CampaignDescription = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(8),
}))

export const CampaignItemContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "baseline",
}))

export const ContentText = styledForMobile(Typography)(({ color, isMobile, theme }) => ({
    color: theme.palette[color].main,
    width: isMobile ? "fit-content" : "50%",
}))

export const ChipList = styled(UiChipList)(() => ({

}))